import React from 'react';
import { useS3Url } from './roHelpers';

export function PhotoThumb({ photoKey, onExpand }) {
  const url = useS3Url(photoKey);
  if (!url) return <div className="ro-photo-loading">⋯</div>;
  return (
    <button className="ro-photo-thumb" onClick={() => onExpand(url)}>
      <img src={url} alt="attachment" />
    </button>
  );
}

export default function PhotoViewer({ uri, onClose }) {
  return (
    <div className="ro-photo-viewer" onClick={onClose}>
      <div className="ro-photo-viewer-inner" onClick={e => e.stopPropagation()}>
        <button className="ro-photo-viewer-close" onClick={onClose}>✕ Close</button>
        <img src={uri} alt="Full size" />
      </div>
    </div>
  );
}
